import { render, staticRenderFns } from "./BookingsPlanning.vue?vue&type=template&id=2912acbb&"
import script from "./BookingsPlanning.vue?vue&type=script&lang=js&"
export * from "./BookingsPlanning.vue?vue&type=script&lang=js&"
import style0 from "./BookingsPlanning.vue?vue&type=style&index=0&id=2912acbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports